import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";
import { ConfigContext } from "../../../Context/ConfigContext/ConfigContext";
import {
  getHistoricoInventarioCombustible,
  getInformacionEncabezadoCXPCombustible,
  getInventarioMensualCombustible,
} from "../../../API/Inventarios/BodegaMateriales/BodegaMaterialesRequests";
import { setTitlePage } from "../../../Services/Config/ConfigService";
import { getLabel } from "../../../Services/Language/LanguageService";
import { baseLang } from "../../../Lang/BaseLang";
import Card from "../../../Components/Card/Card";
import { Button } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";
import AgGrid from "../../../Components/Tables/AgGrid/AgGrid";
import { Calendar } from "primereact/calendar";
import ModalCuentasPorPagarCompras from "../../Proveedores/CuentasPorPagar/ModalCXP/ModalCuentasPorPagarCompras";

const InventarioCombustibleScreen = () => {
  const { userAuth } = useContext(AuthContext);
  const { config } = useContext(ConfigContext);
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [dataHistorico, setDataHistorico] = useState([]);
  const [date, setDate] = useState(new Date());
  const [dialogFactura, setDialogFactura] = useState(false);
  const [IdFactura, setIdFactura] = useState(null);

  const obtenerInformacion = async () => {
    setLoading(true);
    let tempoResumen = [];
    if (activeIndex === 0) {
      tempoResumen = await getInventarioMensualCombustible();
      setData(tempoResumen);
    } else if (activeIndex === 1) {
      let year = date.getFullYear();
      let mes = date.getMonth() + 1;
      tempoResumen = await getHistoricoInventarioCombustible(mes, year);
      setDataHistorico(tempoResumen);
    }
    setLoading(false);
  };

  const OpenDocumento = async (rowData) => {
    let informacionEnviar = {
      NumeroIngreso: rowData?.NoIngreso,
    };
    const tempoCXP = await getInformacionEncabezadoCXPCombustible(
      informacionEnviar
    );
    if (tempoCXP?.length > 0) {
      setIdFactura(tempoCXP[0]?.Id);
      setDialogFactura(true);
    }
  };

  const hideDialog = () => {
    setDialogFactura(false);
  };

  const columns = [
    // PRODUCTO
    {
      headerName: "Producto",
      children: [
        {
          field: "IdProductoSuministro",
          header: "ID",
          headerEn: "ID",
          className: "colum-width-Xlarge",
          body: (rowData) => rowData.IdTransferencia,
          frozen: "frozen",
          className: "XXsmall",
          hidden: userAuth.IdRol === 1,
        },
        {
          field: "CodigoProducto",
          header: "Código Producto",
          headerEn: "Product Code",
          className: "medium",
          align: "center",
          frozen: "frozen",
          onCellDoubleClicked: ({ data }) => {
            if (data?.NoIngreso) {
              OpenDocumento(data);
            }
          },
        },
        {
          field: "NombreProducto",
          header: "Nombre Producto",
          headerEn: "Product Name",
          frozen: "frozen",
          className: "Xlarge",
          align: "center",
          onCellDoubleClicked: ({ data }) => {
            if (data?.NoIngreso) {
              OpenDocumento(data);
            }
          },
        },

        //INICIAL
        {
          headerName: "Inicial",
          children: [
            {
              field: "Inicial",
              Sumary: "sum",
              header: "Inicial",
              headerEn: "Initial",
              className: "medium",
              Format: "Currency",
              align: "center",
              editable: userAuth?.IdRol === 1,
            },
            {
              field: "InicialPrecioL",
              header: "Precio L",
              // headerEn: "Product Name",
              Sumary: "sum",
              className: "medium",
              Format: "Currency",
              align: "center",
              editable: userAuth?.IdRol === 1,
            },
            {
              field: "InicialMontoL",
              header: "Monto L",
              // headerEn: "Product Name",
              align: "center",
              Sumary: "sum",
              className: "medium",
              Format: "Currency",
              editable: userAuth?.IdRol === 1,
            },
            {
              field: "InicialPrecioD",
              header: "Precio $",
              Sumary: "sum",
              // headerEn: "Product Name",
              className: "medium",
              align: "center",
              Format: "Currency",
              editable: userAuth?.IdRol === 1,
            },
            {
              field: "InicialMontoD",
              header: "Monto $",
              Sumary: "sum",
              // headerEn: "Product Name",
              className: "medium",
              Format: "Currency",
              align: "center",
              editable: userAuth?.IdRol === 1,
            },
          ],
        },
        // INGRESO
        {
          headerName: "Ingreso",
          children: [
            {
              field: "Ingreso",
              header: "Ingreso",
              // headerEn: "Ingreso",
              className: "medium",
              Sumary: "sum",
              Format: "Currency",
              align: "center",
              editable: userAuth?.IdRol === 1,
            },
            {
              field: "IngresoPrecioL",
              header: "Precio L",
              // headerEn: "IngresoPrecioL",
              Sumary: "sum",
              Format: "Currency",
              className: "medium",
              align: "center",
              editable: userAuth?.IdRol === 1,
            },
            {
              field: "IngresoMontoL",
              header: "Monto L",
              // headerEn: "IngresoMontoL",
              Format: "Currency",
              Sumary: "sum",
              className: "medium",
              align: "center",
              editable: userAuth?.IdRol === 1,
            },
            {
              field: "IngresoPrecioD",
              header: "Precio $",
              Format: "Currency",
              Sumary: "sum",
              // headerEn: "IngresoPrecioD",
              className: "medium",
              align: "center",
              editable: userAuth?.IdRol === 1,
            },
            {
              field: "IngresoMontoD",
              header: "Monto $",
              // headerEn: "IngresoMontoD",
              Sumary: "sum",
              Format: "Currency",
              className: "medium",
              align: "center",
              editable: userAuth?.IdRol === 1,
            },
          ],
        },
        // SALIDA
        {
          headerName: "Salida",
          children: [
            {
              field: "Salida",
              header: "Salida",
              // headerEn: "Salida",
              Format: "Currency",
              Sumary: "sum",
              className: "medium",
              align: "center",
              editable: userAuth?.IdRol === 1,
            },
            {
              field: "SalidaPrecioL",
              header: "Precio L",
              // headerEn: "SalidaPrecioL",
              Sumary: "sum",
              Format: "Currency",
              className: "medium",
              align: "center",
              editable: userAuth?.IdRol === 1,
            },
            {
              field: "SalidaMontoL",
              header: "Monto L",
              // headerEn: "SalidaMontoL",
              className: "medium",
              Sumary: "sum",
              Format: "Currency",
              align: "center",
              editable: userAuth?.IdRol === 1,
            },
            {
              field: "SalidaPrecioD",
              header: "Precio $",
              // headerEn: "SalidaPrecioD",
              className: "medium",
              Sumary: "sum",
              Format: "Currency",
              align: "center",
              editable: userAuth?.IdRol === 1,
            },
            {
              field: "SalidaMontoD",
              header: "Precio $",
              // headerEn: "SalidaMontoD",
              className: "medium",
              Sumary: "sum",
              Format: "Currency",
              align: "center",
              editable: userAuth?.IdRol === 1,
            },
          ],
        },
        // INVENTARIO
        {
          headerName: "Inventario",
          children: [
            {
              field: "Inventario",
              header: "Inventario",
              // headerEn: "Inventario",
              className: "medium",
              Sumary: "sum",
              Format: "Currency",
              align: "center",
              editable: userAuth?.IdRol === 1,
            },
            {
              field: "InventarioPrecioL",
              header: "Precio L",
              // headerEn: "InventarioPrecioL",
              Sumary: "sum",
              className: "medium",
              Format: "Currency",
              align: "center",
              editable: userAuth?.IdRol === 1,
            },
            {
              field: "InventarioMontoL",
              header: "Monto L",
              // headerEn: "InventarioMontoL",
              Sumary: "sum",
              className: "medium",
              Format: "Currency",
              align: "center",
              editable: userAuth?.IdRol === 1,
            },
            {
              field: "InventarioPrecioD",
              header: "Precio $",
              // headerEn: "InventarioPrecioD",
              Sumary: "sum",
              Format: "Currency",
              className: "medium",
              align: "center",
              editable: userAuth?.IdRol === 1,
            },
            {
              field: "InventarioMontoD",
              header: "Monto $",
              // headerEn: "InventarioMontoD",
              className: "medium",
              Format: "Currency",
              align: "center",
              Sumary: "sum",
              editable: userAuth?.IdRol === 1,
            },
          ],
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: data,
    loading: loading,
  };

  const columns2 = [
    // PRODUCTO
    {
      headerName: "Producto",
      children: [
        {
          field: "IdDetalle",
          header: "IdDetalle",
          headerEn: "IdDetalle",
          className: "colum-width-Xlarge",
          body: (rowData) => rowData.IdTransferencia,
          frozen: "frozen",
          className: "Xsmall",
          hidden: userAuth.IdRol === 1,
        },
        {
          field: "CodigoProducto",
          header: "Código Producto",
          headerEn: "Product Code",
          Sumary: "count",
          className: "small",
          align: "center",
          // Format: "Modal",
          frozen: "frozen",
        },
        {
          field: "NombreProducto",
          header: "Nombre Producto",
          headerEn: "Product Name",
          frozen: "frozen",
          className: "Xlarge",
          align: "center",
        },
      ],
    },

    // INICIAL
    {
      headerName: "Inicial",
      children: [
        {
          field: "InicialQty",
          header: "Inicial",
          headerEn: "Initial",
          Sumary: "sum",
          className: "medium",
          align: "center",
          Format: "Currency",
        },
        {
          field: "InicialPrecioL",
          header: "Precio L",
          Sumary: "sum",
          headerEn: "Price L",
          Format: "Currency",
          className: "medium",
          align: "center",
        },
        {
          field: "InicialCostoL",
          header: "Monto L",
          Sumary: "sum",
          headerEn: "Monto L",
          Format: "Currency",
          className: "medium",
          align: "center",
        },
        {
          field: "InicialPrecio",
          header: "Precio $",
          Sumary: "sum",
          // headerEn: "Product Name",
          className: "medium",
          align: "center",
          Format: "Currency",
        },
        {
          field: "InicialMonto",
          header: "Monto $",
          Sumary: "sum",
          // headerEn: "Product Name",
          className: "medium",
          Format: "Currency",
          align: "center",
        },
      ],
    },

    // INGRESO
    {
      headerName: "Ingreso",
      children: [
        {
          field: "IngresoQty",
          header: "Ingreso",
          headerEn: "Entry",
          className: "medium",
          Sumary: "sum",
          Format: "Currency",
          align: "center",
        },
        {
          field: "IngresoPrecioL",
          header: "Precio L",
          // headerEn: "IngresoPrecioL",
          Sumary: "sum",
          Format: "Currency",
          className: "medium",
          align: "center",
        },

        {
          field: "IngresoCostoL",
          header: "Monto L",
          Sumary: "sum",
          Format: "Currency",
          headerEn: "Entry Cost L",
          className: "medium",
          align: "center",
        },

        {
          field: "IngresoPrecio",
          header: "Precio $",
          headerEn: "Entry Price",
          className: "medium",
          Sumary: "sum",
          Format: "Currency",
          align: "center",
        },
        {
          field: "IngresoCosto",
          header: "Monto $",
          Sumary: "sum",
          headerEn: "Entry Cost",
          className: "medium",
          align: "center",
          Format: "Currency",
        },
      ],
    },

    // SALIDA
    {
      headerName: "Salida",
      children: [
        {
          field: "SalidaQty",
          Sumary: "sum",
          header: "Salida",
          Format: "Currency",
          headerEn: "Quantity",
          className: "medium",
          align: "center",
        },
        {
          field: "SalidaPrecioL",
          header: "Precio L",
          Sumary: "sum",
          headerEn: "Price L",
          Format: "Currency",
          className: "medium",
          align: "center",
        },
        {
          Sumary: "sum",
          field: "SalidaCostoL",
          header: "Monto L",
          headerEn: "MontoL L",
          Format: "Currency",
          className: "medium",
          align: "center",
        },
        {
          Sumary: "sum",
          field: "SalidaPrecio",
          Format: "Currency",
          header: "Precio $",
          headerEn: "Price $",
          className: "medium",
          align: "center",
        },
        {
          field: "SalidaCosto",
          Format: "Currency",
          header: "Monto $",
          headerEn: "Monto $",
          Sumary: "sum",
          className: "medium",
          align: "center",
        },
      ],
    },

    // INVENTARIO
    {
      headerName: "Inventario",
      children: [
        {
          field: "InvQty",
          header: "Inventario",
          Sumary: "sum",
          headerEn: "Return Quantity",
          className: "medium",
          Format: "Currency",
          align: "center",
        },
        {
          field: "InvPrecioL",
          header: "Precio L",
          Sumary: "sum",
          headerEn: "Price L",
          className: "medium",
          Format: "Currency",
          align: "center",
        },
        {
          field: "InvCostoL",
          header: "Monto L",
          headerEn: "Monto L",
          className: "medium",
          Sumary: "sum",
          Format: "Currency",
          align: "center",
        },
        {
          field: "InvPrecio",
          header: "Precio $",
          Sumary: "sum",
          headerEn: "Price $",
          className: "medium",
          Format: "Currency",
          align: "center",
        },
        {
          field: "InvCosto",
          header: "Monto $",
          headerEn: "Monto $",
          className: "medium",
          Sumary: "sum",
          Format: "Currency",
          align: "center",
        },
      ],
    },
  ];

  const table2 = {
    Columns: columns2,
    Data: dataHistorico,
    loading: loading,
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "Combustibles", config.language));
    obtenerInformacion();
  }, [activeIndex, date]);

  return (
    <div className="mt-2">
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "Combustibles", config.language)}</h3>
            {activeIndex === 1 && (
              <Calendar
                value={date}
                onChange={(e) => setDate(e.value)}
                view="month"
                dateFormat="mm/yy"
                showIcon
              />
            )}
            <Button
              icon="pi pi-sync"
              className="mx-1"
              onClick={obtenerInformacion}
            />
          </div>
        }
        contenido={
          <div
            className="pt-4"
            style={{ height: "90vh" }}
            id="IngresosCombustibles"
          >
            <TabView
              className="col-12 homeTabView"
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header="Inventario Mensual">
                <div
                  className="pt-4"
                  style={{ height: "84vh" }}
                  id="ResumenInventario"
                >
                  <AgGrid table={table} />
                </div>
              </TabPanel>
              <TabPanel header="Historico">
                <div className="pt-4" style={{ height: "84vh" }} id="Historico">
                  <AgGrid table={table2} />
                </div>
              </TabPanel>
            </TabView>
          </div>
        }
      />

      <ModalCuentasPorPagarCompras
        dialogCuentas={dialogFactura}
        hideDialog={hideDialog}
        IdFactura={IdFactura}
      />
    </div>
  );
};

export default InventarioCombustibleScreen;
